import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./App";
import * as serviceWorker from "./serviceWorker";


//import ErrorBoundary from "./Components/ErrorBoundary";

const container = document.getElementById('bl-rf-root');
const root = createRoot(container);
root.render(
	// <ErrorBoundary>
	<App tab="home" />
	// </ErrorBoundary>
);

serviceWorker.unregister();
